// src/views/balances/actions/components/ContractActionsRow.js
import React from 'react';
import { TableRow, Tooltip, Typography } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import momentLocalTimezone from 'src/utils/momentLocalTimezone';
import { formatPositiveAmount } from 'src/utils/formatAmout';
import { roundNumberToDecimals } from 'src/utils/common';
import StatusBadge from 'src/components/StatusBadge';
import OverflowTipography from 'src/components/OverflowTipography';

const ACTION_TYPE_TONE = {
  ALTA: 'success',
  APORTACION: 'warning',
  TERMINACION: 'neutral',
  TERMINACION_ANTICIPADA: 'error',
  CESION: 'info'
};

const ContractActionsRow = ({
  date,
  folio,
  contractId,
  clientFullName,
  clientId,
  equipmentId,
  equipment,
  equipmentBrand,
  action,
  actionType,
  amount
}) => {
  return (
    <TableRow hover>
      <TableCell align="left">
        {momentLocalTimezone(date).format('DD/MM/YYYY')}
      </TableCell>
      <TableCell align="left">
        <Link to={`/contracts/${contractId}`} style={{ textDecoration: 'none' }}>
          {folio}
        </Link>
      </TableCell>
      <TableCell align="left">
        {clientFullName.length > 45 ? (
          <Tooltip title={clientFullName}>
            <Link to={`/clients/detail/${clientId}`}>
              <Typography
                sx={{
                  fontFamily: 'Roboto',
                  fontSize: '14px',
                  fontWeight: '400',
                  lineHeight: '1.43'
                }}
              >
                {`${clientFullName.slice(0, 45)}...`}
              </Typography>
            </Link>
          </Tooltip>
        ) : (
          <Link to={`/clients/detail/${clientId}`}>
            <Typography
              sx={{
                fontFamily: 'Roboto',
                fontSize: '14px',
                fontWeight: '400',
                lineHeight: '1.43'
              }}
            >
              {clientFullName}
            </Typography>
          </Link>
        )}
      </TableCell>
      <TableCell align="left">
        <span style={{ display: 'grid', gap: 3 }}>
          <OverflowTipography title={equipment} maxWidth="190px">
            <Link
              style={{ textDecoration: 'none' }}
              to={`/inventory/${equipmentId}`}
            >
              {equipment}
            </Link>
          </OverflowTipography>
          <Typography variant="caption" color="textSecondary">
            {equipmentBrand}
          </Typography>
        </span>
      </TableCell>
      <TableCell align="left">
        <StatusBadge tone={ACTION_TYPE_TONE[actionType] ?? 'neutral'}>
          {action}
        </StatusBadge>
      </TableCell>
      <TableCell align="center">
        {amount ? formatPositiveAmount(roundNumberToDecimals(amount)) : '-'}
      </TableCell>
    </TableRow>
  );
};

ContractActionsRow.propTypes = {
  date: PropTypes.string.isRequired,
  folio: PropTypes.string.isRequired,
  contractId: PropTypes.number.isRequired,
  clientFullName: PropTypes.string.isRequired,
  clientId: PropTypes.number.isRequired,
  equipmentId: PropTypes.number.isRequired,
  equipment: PropTypes.string.isRequired,
  equipmentBrand: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  actionType: PropTypes.string.isRequired,
  amount: PropTypes.number
};

ContractActionsRow.defaultProps = {
  amount: 0
};

export default ContractActionsRow;
